import React, { ReactNode } from 'react';
import ReactPlaceholder from 'react-placeholder';
import {
  ListItemWrapperPlaceholder,
  NameFieldPlaceholder,
  DetailFieldPlaceholder,
  DateFieldPlaceholder,
  LinksWrapperPlaceholder,
  ImgWrapperPlaceholder,
} from './skeletonListData.styles';

type Props = {
  ready: boolean;
  children: ReactNode;
};

const SkeletonListData = (props: Props) => {
  const { ready, children } = props;
  const placeholders = Array(1, 2, 3);
  const GhostPlaceholder = (
    <div>
      {placeholders.map(id => (
        <ListItemWrapperPlaceholder key={id}>
          <ImgWrapperPlaceholder />
          <DetailFieldPlaceholder>
            <NameFieldPlaceholder />
            <DateFieldPlaceholder />
            <LinksWrapperPlaceholder />
          </DetailFieldPlaceholder>
        </ListItemWrapperPlaceholder>
      ))}
    </div>
  );

  return (
    <ReactPlaceholder ready={ready} customPlaceholder={GhostPlaceholder}>
      {children}
    </ReactPlaceholder>
  );
};

export default SkeletonListData;
